import { Button, Form } from 'react-bootstrap'
import { useMutation, useQueryClient } from 'react-query'

import { FormInput } from '../../formControl'
import { useApi, useLoading, useYupForm } from '../../../hooks'
import { schemaUpdate } from './schema'
import toast from '../../toast'
import useContainerContext from '../../containerContext'

const UpdateUser = () => {
  const { memberSelected, updateManagerState } = useContainerContext()
  const queryClient = useQueryClient()
  const { mainService } = useApi()
  // AB#42003: only the two fields the dialog edits, never the member snapshot.
  const { isLoading, mutate: edit } = useMutation(async ({ firstName, lastName }) => {
    await mainService.editMember(memberSelected._id, { firstName, lastName })
    await queryClient.invalidateQueries(['list-user'])
  }, {
    onSuccess: () => {
      toast.success({ title: 'User Updated', body: 'success' })
      updateManagerState({ memberSelected: null })
    },
    onError: (err) => toast.error({ title: 'Edit User', body: (err && err.message) || 'Update failed' })
  })

  useLoading(isLoading)

  const defaultValue = {
		firstName: memberSelected?.firstName,
		lastName: memberSelected?.lastName,
	}

	const { handleSubmit, register, formState: { errors } } = useYupForm(schemaUpdate, defaultValue)

	return (
		<Form onSubmit={handleSubmit(edit)} className='form form-default py-4 px-3 mt-3 h-100'>
			<div className='pb-5'>
        <div className='fs-6 text-start pb-3'>
          <strong>Edit User info</strong>
        </div>
        <FormInput
          label='Email'
          disabled
          placeholder='Type email here'
          wrapperClass='mb-3'
          className='bg-body'
          value={memberSelected?.email}
        />
        <FormInput
          basic
          label='First Name'
          placeholder='Type First Name'
          error={errors?.firstName}
          errorMessage={errors?.firstName?.message}
          wrapperClass='mb-3'
          {...register('firstName')}
        />

        <FormInput
          basic
          label='Last Name'
          placeholder='Type Last Name'
          error={errors?.lastName}
          errorMessage={errors?.lastName?.message}
          {...register('lastName')}
        />
      </div>

      <Button type='submit' className='w-100 mt-4 fs-7 text-uppercase'>
        Save
      </Button>
		</Form>
	)
}

export default UpdateUser
